import { render } from "./KpiColumn.vue?vue&type=template&id=73a47846&scoped=true"
import script from "./KpiColumn.vue?vue&type=script&lang=js"
export * from "./KpiColumn.vue?vue&type=script&lang=js"

import "./KpiColumn.vue?vue&type=style&index=0&id=73a47846&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73a47846"]])

export default __exports__